import { rootApi } from "../../api/rootApi";

export const inventorySBApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getCheckoutList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/inventory/checkoutList`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getCheckoutInfo: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/inventory/checkoutInfo`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getDistributorWisePointInfo: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/inventory/distributorWiseInfo`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const { useGetCheckoutListMutation, useGetCheckoutInfoMutation, useGetDistributorWisePointInfoMutation } = inventorySBApi;
